import React from "react";
import { useLocation } from "react-router-dom";
import SimpleHeader from "./SimpleHeader";
import Footer from "./Footer";

const Layout = ({ children }) => {
  const location = useLocation();
  const isDashboard = location.pathname === "/dashboard";
  const isInvestorDashboard = location.pathname === "/investor-dashboard";

  return (
    <div className="min-h-screen flex flex-col">
      {/* Only show SimpleHeader for non-dashboard pages */}
      {!isDashboard && !isInvestorDashboard && <SimpleHeader />}
      <main className="flex-grow">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
